import {SAVEDATA, BACKPREVFORM, HASREZULT, ERROR, STARTLOADING} from '../types'
import api from '../../axios/api'
import { sendReportError } from './authorization'

export const saveData = (data, onlySave) => dispatch => 
  dispatch({type: SAVEDATA, data, onlySave})
export const backPrevForm = () => dispatch => 
  dispatch({type: BACKPREVFORM})
export const showRezultForm = (message, showButtonResult) => dispatch => 
  dispatch({type: HASREZULT, rezult: message, showButtonResult})

export const submitData = data => dispatch => {
  const newFormData = {}
  Object.keys(data)
  .filter(data => !['noPatronymic', 'clickedDocType'].some(ignore => data === ignore))
  .forEach(key => {
    if(key === 'isWebBankClient'){
      newFormData[key] = data[key]
    } else if(data[key] && (typeof data[key] === 'number' ? data[key] !== 0 : data[key].toString().length))
      newFormData[key] = data[key]
  })
  dispatch({type: STARTLOADING})
  const paramsReport = {
    typeReq: 'request',
    urlApi: '/api/ccs/application/create',
    applicationId: newFormData.applicationId,
    phone: newFormData.phone
  }
  sendReportError(paramsReport)
  api.create(newFormData).then(({data}) => {
    dispatch({type: HASREZULT, rezult: data.message})
  })
  .catch(error => {
    const paramsReport = {
      errorConfig: error,
      applicationId: newFormData.applicationId,
      phone: newFormData.phone
    }
    sendReportError(paramsReport)
    dispatch({type: ERROR, codeStatus: error.response ? error.response.status : 'failed'})
  })
}
  
export const saveHistory = data => () => api.saveHistory(data)